import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { RouteConfig, NavigationInstruction, Router } from 'aurelia-router';
import { Toaster } from 'app/shared/lib/toaster';
import { Api } from 'app/shared/lib/api/api';
import { State } from 'app/shared/lib/state';
import { validate } from 'app/shared/elements/ess-rule';
import { LoginContext } from 'app/shared/lib/login-context';
import { guid } from 'app/shared/lib/guid';


type UserMethod = 'new' | 'existing';

@autoinject()
export class AcceptInvitationViewModel {

    ////****************** Fields and Properties ************************************////
    protected code: string | null = null;
    protected loginName: string | null = null;
    protected password: string | null = null;
    protected firstName?: string;
    protected lastName?: string;

    protected userMethod: UserMethod = 'new';
    protected errorMessage: string | null = null;

    protected validateForm = validate;
    protected processing: boolean = false;
    protected readonly state: State = new State();

    protected id: guid = guid();


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly router: Router,
        protected readonly api: Api,
        //protected readonly invitationContext: InvitationContext,
        private readonly loginContext: LoginContext,
        private readonly toaster: Toaster,
        private readonly logger: AppLogger) {

        this.logger.source = this;
        this.logger.target = 'console';
    }

    protected async activate({ code }: { code?: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        this.code = code || null;
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected async process() {
        this.processing = true;

        const { code, loginName, password, firstName, lastName } = this;
        if(!(code && loginName && password)) {
            this.logger.error(`Missing some required values`);
            return;
        }
        try {
            this.state.beginSave();

            const response = await this.api.acceptInvitation(code, loginName, password, firstName, lastName);
            if(response.isSuccessful) {
                this.errorMessage = null;
                this.toaster.standard.success();
                this.loginContext.resetCredentials();
                this.loginContext.loginName = this.loginName || '';
                this.loginContext.password = this.password || '';
                this.router.navigateToRoute('checkin');
            }
            else {
                this.errorMessage = 'Unable to accept invitation.';
            }
        }
        catch(error) {
            this.logger.error('Unable to accept invitation.', error);
            this.errorMessage = 'Unable to accept invitation.';
        }
        finally {
            this.processing = false;
            this.state.endSave();
        }
    }


    ////****************** Service Calls ********************************************////

}
